import { updateMultipleElements } from '../actions/elementActions';
import { getElementId, getLabels } from '../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { toArray } from '../../../common/utils/immutableHelper';

export const addLabelToElements = (elements: Immutable.List<ImMNElement>, labelId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (elementLabels.includes(labelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: [...elementLabels, labelId],
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};

export const removeLabelFromElements = (elements: Immutable.List<ImMNElement>, labelId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (!elementLabels.includes(labelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: elementLabels.filter((id: string) => id !== labelId),
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};

export const replaceLabelOnElements = (
    elements: Immutable.List<ImMNElement>,
    oldLabelId: string,
    newLabelId: string,
) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (!elementLabels.includes(oldLabelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: elementLabels.map((id: string) => (id === oldLabelId ? newLabelId : id)),
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};
